import { CustomRulesWebComponent } from './component/CustomRulesWebComponent';
import { WEB_COMPONENT_CUSTOM_RULES } from '../../webcomponents.constants';

export { CustomRulesWebComponent };

window.customElements.define(WEB_COMPONENT_CUSTOM_RULES, CustomRulesWebComponent);
